
import { Component, OnDestroy, OnInit, ViewChild, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms'
import { AuthenticationApiService } from '../../_services'
import { first, filter, startWith } from 'rxjs/operators'
import { Router, ActivatedRoute } from '@angular/router'
import { MessageService } from '@openng/optimus-ui/api'
import { FuseqAuthService, FuseqService, sanitizeReturnUrl } from '../../FuseQ'
import { FuseqSessionService } from '../../FuseQ/session.service'

import sha256 from 'sha256'
import { MsalBroadcastService, MsalService } from '@azure/msal-angular'
import { EventMessage, EventType } from '@azure/msal-browser'
// import { FuseqSocketService } from '../../FuseQ/fuseq-socket/fuseqSocket.service'
import { Observable, Subscription } from 'rxjs'
import { FuseqRaidenService } from '../../FuseQ/fuseq-raiden/fuseqRaiden.service'

import { OptimUiSharedModule } from '../../shared/optimus-ui-shared.module';
import { MaintenanceBannerComponent } from '../../_shared/maintenance/maintenance-banner.component';
@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [OptimUiSharedModule, CommonModule, FormsModule, ReactiveFormsModule, MaintenanceBannerComponent]
})

export class LoginComponent implements OnInit {
  title = 'Login'
  loginForm: FormGroup
  submitted = false
  returnUrl: string
  loading = signal(false)
  browserSupported = false
  checkSiteminder = false
  demoMode = false
  showISEAlarm = false
  customerLogo: ''
  projectLogo
  projectName = 'AWP-UI'
  constructor (
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly messageService: MessageService,
    private readonly apiService: AuthenticationApiService,
    private readonly fuseqService: FuseqService,
    private fuseqUser: FuseqSessionService,
    private readonly fuseqAuthService: FuseqAuthService,
    private readonly msalService: MsalService,
    private readonly msalBroadcastService: MsalBroadcastService,
    private readonly fuseqRaiden: FuseqRaidenService
    // private readonly fuseqSocketService: FuseqSocketService

  ) {
    /* if (this.authService.currentUserValue || this.authService.isLoggedIn()) {
          //this.authService.checkToken();
        } */
  }

  forgotModalVisible = false

  get f () { return this.loginForm.controls }
  /* document
    documents: Observable<string[]>
    currentDoc: string
    _docSub: Subscription
    ngOnDestroy () {
      this._docSub.unsubscribe()
    }

    loadDoc (id: string) {
      console.log('loading')
      this.fuseqSocketService.getDocument(id)
    }

    newDoc () {
      this.fuseqSocketService.newDocument()
    }

    editDoc () {
      console.log('emit: ', this.document)
      this.fuseqSocketService.editDocument(this.document)
    } */

  ngOnInit () {

    /* this.fuseqSocketService.onFetchDocs().subscribe((data: any) => {
          console.log(data)
          this.documents = data
        })
        this._docSub = this.fuseqSocketService.currentDocument.subscribe(document => {
          this.document = document
        })
        this.loadDoc('11') */
    this.customerLogo = this.fuseqService.getProjectInfo('customerLogo')
    this.projectLogo = this.fuseqService.getProjectInfo('projectLogo')
    this.projectName = this.fuseqService.getProjectInfo('projectName')
    this.viewlogin.set(false)
    this.viewAzure.set(false)
    this.apiService.pre_auth().subscribe({
      next: (settings) => {
        console.log(settings)
        const isMfaEnabled = !!settings?.mfa_auth && window.location.hostname.includes('posteitaliane')
        this.viewAzure.set(isMfaEnabled)
        this.viewlogin.set(!isMfaEnabled)
        console.log('isMfaEnabled:', isMfaEnabled, 'settings:', settings, 'viewAzure:', this.viewAzure(), 'viewlogin:', this.viewlogin())
      },
      error: () => {
        this.viewAzure.set(false)
        this.viewlogin.set(false)
      }
    })
    this.browserSupported = this.getBrowserName()
    this.loginForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(1)]]
    })
    this.returnUrl = sanitizeReturnUrl(this.activatedRoute.snapshot.queryParams.returnUrl)
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe((result: EventMessage) => {
        console.log('msal', result)
      })
  }

  getBrowserName () {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.includes('edge') && !!(window as any).edge:
        return true
      case agent.includes('opr') && !!(window as any).opr:
        return false
      case agent.includes('chrome') && !!(window as any).chrome:
        return true
      case agent.includes('trident'):
        return false
      case agent.includes('firefox'):
        return true
      case agent.includes('safari'):
        return true
      default:
        return false
    }
  }

  async delay (time) {
    return await new Promise(resolve => setTimeout(resolve, time))
  }

  onLoginFormSubmit () {
    this.fuseqUser.session = null
    this.submitted = true

    if (this.loginForm.invalid) {
      this.messageService.add({ severity: 'error', detail: 'Compilare correttamente il form' })
      return
    }

    const { userName, password } = this.f
    this.loading.set(true)

    /* if (userName.value === 'sysadmin' && password.value === 'admin') {
          const user = {
            is_admin: true,
            username: 'admin',
            last_action: Date.now(),
            permissions: [],
            groups: ['TLC', 'Network']
          }
          user.permissions.push('SYSADMIN_LOCAL')
          this.fuseqUser.session = user

          const dashboardRoute = 'awpDashboard/dashboard'
          this.delay(500).then(async () => await this.router.navigate([dashboardRoute])).finally(() => {
            this.loading.set(false)
          })
        } else { */
    this.apiService.login(userName.value, password.value).pipe(first()).subscribe(
      data => {
        if (data) {
          if (data.status === 'ResetPasswordLogin' || data.status === 'LastPasswordChange') {
            this.viewexpired.set(true)
            this.verificationCode = data.verificationCode
            this.viewlogin.set(false)
            this.isDisable.set(true)
            console.log(this.viewexpired(), this.verificationCode)
            /* if (data.status === 'LastPasswordChange') {
                            this.viewexpired.set(true)
                            this.verificationCode = data.Code
                          } (data.verificationCode) */
          } else {
            this.fuseqUser.session = data
            this.fuseqRaiden.updateUserId(data.username)
            this.messageService.add({ severity: 'success', detail: 'Login successful' })

            /* if (data.permissions.indexOf('OPERATOR') !== -1) {
                            this.delay(500).then(async () => await this.router.navigate(['awpWorkflow/awp-workflow'])).finally(() => {
                              this.loading.set(false);
                            });
                          } else { */
            let destination = ''
            if (data.permissions.indexOf('OPERATOR') !== -1) {
              destination = '/awpDashboard/wf/awp-workflowFortinet'
            } else if (data.permissions.indexOf('OPERATOR_CISCO') !== -1) {
              destination = '/awpDashboardCisco/wf/awp-workflowCisco'
            } else if (data.permissions.indexOf('MENU_AWP_DASHBOARD_CISCO_ACTIONS') !== -1) {
              destination = '/awpDashboardCisco/actionsDashboard'
            } else if (data.permissions.indexOf('MENU_AWP_DASHBOARD') !== -1) {
              destination = '/awpDashboard/dashboard'
            } else if (data.permissions.indexOf('MENU_VOIP_DASHBOARD') !== -1) {
              destination = '/voip/voip-dashboard'
            } else if (data.permissions.indexOf('MENU_VOIP_DASHBOARD_NPFASTWEB') !== -1) {
              destination = '/voipfastweb/voip-dashboardNPFastweb'
            } else if (data.permissions.indexOf('MENU_NRD_Dashboard') !== -1) {
              destination = '/NRD/NRD-dashboard'
            } else {
              destination = '/awpDashboard/actionsDashboard'
            }
            if (data.groups && data.groups.indexOf('Immobiliare') !== -1) {
              destination = '/awpDashboard/rtu_pianificazioni'
            }
            if (data.groups && data.groups.indexOf('TopManagement') !== -1) {
              destination = '/perimetro-awp'
            }
            const dashboardRoute = destination /* data.permissions.indexOf('OPERATOR') !== -1
              ? '/awpDashboard/wf/awp-workflowFortinet'
              : data.permissions.indexOf('OPERATOR_CISCO') !== -1
                ? '/awpDashboardCisco/wf/awp-workflowCisco'
                : data.permissions.indexOf('MENU_AWP_DASHBOARD_CISCO_ACTIONS') !== -1
                  ? '/awpDashboardCisco/actionsDashboard'
                  : data.permissions.indexOf('MENU_AWP_DASHBOARD') !== -1
                    ? 'awpDashboard/dashboard'
                    : data.permissions.indexOf('MENU_VOIP_DASHBOARD') !== -1
                      ? 'voip/voip-dashboard'
                      : 'awpDashboard/actionsDashboard'*/
            const redirectRoute = this.returnUrl && this.returnUrl !== '**' ? this.returnUrl : dashboardRoute
            this.delay(500).then(async () => await this.router.navigateByUrl(redirectRoute)).finally(() => {
              this.loading.set(false)
            })
          }
        } else {
          this.messageService.add({ severity: 'error', detail: 'utente null' })
          this.loading.set(false)
        }
      },
      error => {
        if (!error.isintercepted) {
          this.messageService.add({ severity: 'error', detail: 'username or password are wrong' })
        }
        if (error.status === 406) {
          this.showISEAlarm = true
        }
        this.loading.set(false)
      }
    )
    // }
  }

  viewAzure = signal(false)
  viewlogin = signal(false)
  viewforgot = signal(false)
  usernamereset = null
  sendRequestReset = signal(true)
  newPassword = null
  oldPassword = null
  verificationToken = null
  verificationCode = null
  viewexpired = signal(false)
  cpassword = null

  requestReset (username) {
    console.log(username)
    this.apiService.forgotPassword(username).subscribe(data => {
      console.log(data)
      this.sendRequestReset.set(false)
    }, error => {
      console.log(error)
    })
  }

  resetPassword () {
    this.fuseqAuthService.checkPSWStrength(this.newPassword, this.usernamereset).then(psw => {
      console.log(psw)
      this.apiService.resetPassword({ username: this.usernamereset, verificationToken: this.verificationToken, newPassword: sha256(this.newPassword) }).subscribe(data => {
        this.messageService.add({ severity: 'success', detail: 'Password updated' })
        this.usernamereset = null
        this.sendRequestReset.set(false)
        this.viewforgot.set(false)
        this.viewlogin.set(true)
        this.newPassword = null
        this.verificationToken = null
        this.cpassword = null
      }, error => { console.log(error) })
    }).catch(e => {
      this.messageService.add({ severity: 'warn', detail: e })
      console.log(e)
      // this.PasswordMessage = e
    })
  }

  resetformforgot () {
    this.usernamereset = null
    this.sendRequestReset.set(false)
    this.viewforgot.set(false)
    this.viewlogin.set(true)
    this.cpassword = null
    this.newPassword = null
    this.verificationCode = null
    this.loading.set(false)
  }

  resetformexpired () {
    this.usernamereset = null
    this.sendRequestReset.set(false)
    this.viewlogin.set(true)
    this.viewexpired.set(false)
    this.cpassword = null
    this.newPassword = null
    this.verificationCode = null
  }

  isDisable = signal(true)
  PasswordMessage = signal('')

  confirmpassword (type) {
    console.log(this.cpassword, this.newPassword)
    if (this.cpassword === '' || this.newPassword === '') {
      this.isDisable.set(true)
      this.PasswordMessage.set('Password cannot be empty')
    } else if (this.cpassword !== this.newPassword) {
      console.log(this.cpassword, this.newPassword)
      this.isDisable.set(true)
      this.PasswordMessage.set('Password Mismatch')
    } else {
      if (type === 'reset') {
        if (this.usernamereset !== null && this.usernamereset.length > 0 &&
          this.cpassword !== null && this.cpassword.length > 0 &&
          this.oldPassword !== null && this.oldPassword.length > 0 &&
          this.newPassword !== null && this.newPassword.length > 0 &&
          this.cpassword === this.newPassword) {
          console.log(this.oldPassword, this.usernamereset)
          this.isDisable.set(false)
          this.PasswordMessage.set('')
        }
      }
      if (type === 'forgot') {
        if (this.usernamereset !== null && this.usernamereset.length > 0 &&
          this.cpassword !== null && this.cpassword.length > 0 &&
          this.verificationToken !== null && this.verificationToken.length > 0 &&
          this.newPassword !== null && this.newPassword.length > 0 &&
          this.cpassword === this.newPassword) {
          console.log(this.oldPassword, this.usernamereset)
          this.isDisable.set(false)
          this.PasswordMessage.set('')
        }
      }
    }
  }

  checkuser (type) {
    console.log(this.oldPassword, this.usernamereset, this.cpassword, this.newPassword)
    /* if (this.usernamereset === null || this.usernamereset === '') {
          this.isDisable.set(true)
        } else if ((this.cpassword === this.newPassword) &&
          (this.newPassword !== null) &&
          (this.oldPassword !== null && this.oldPassword.length > 0) &&
          (this.usernamereset !== null || this.usernamereset.length > 0)) {
          console.log(this.oldPassword, this.usernamereset)
          this.isDisable.set(false)
        } */
    if (type === 'reset') {
      if (this.usernamereset !== null && this.usernamereset.length > 0 &&
        this.cpassword !== null && this.cpassword.length > 0 &&
        this.oldPassword !== null && this.oldPassword.length > 0 &&
        this.newPassword !== null && this.newPassword.length > 0 &&
        this.cpassword === this.newPassword) {
        this.isDisable.set(false)
      } else {
        this.isDisable.set(true)
      }
    }
    if (type === 'forgot') {
      if (this.usernamereset !== null && this.usernamereset.length > 0 &&
        this.cpassword !== null && this.cpassword.length > 0 &&
        this.verificationToken !== null && this.verificationToken.length > 0 &&
        this.newPassword !== null && this.newPassword.length > 0 &&
        this.cpassword === this.newPassword) {
        this.isDisable.set(false)
      } else {
        this.isDisable.set(true)
      }
    }
  }

  checkoldpassword () {
    if (this.usernamereset !== null && this.usernamereset.length > 0 &&
      this.cpassword !== null && this.cpassword.length > 0 &&
      this.oldPassword !== null && this.oldPassword.length > 0 &&
      this.newPassword !== null && this.newPassword.length > 0 &&
      this.cpassword === this.newPassword) {
      this.isDisable.set(false)
    } else {
      this.isDisable.set(true)
    }
  }

  checkToken () {
    if (this.usernamereset !== null && this.usernamereset.length > 0 &&
      this.cpassword !== null && this.cpassword.length > 0 &&
      this.verificationToken !== null && this.verificationToken.length > 0 &&
      this.newPassword !== null && this.newPassword.length > 0 &&
      this.cpassword === this.newPassword) {
      this.isDisable.set(false)
    } else {
      this.isDisable.set(true)
    }
  }

  changePassword () {
    this.fuseqAuthService.checkPSWStrength(this.newPassword, this.usernamereset).then(psw => {
      console.log(psw)
      this.apiService.resetPassword({ username: this.usernamereset, verificationCode: this.verificationCode, oldPassword: this.oldPassword, newPassword: sha256(this.newPassword) }).subscribe(data => {
        this.messageService.add({ severity: 'success', detail: 'Password updated' })
        this.usernamereset = null
        this.viewexpired.set(false)
        this.viewlogin.set(true)
        this.newPassword = null
        this.verificationCode = null
        this.cpassword = null
        this.loading.set(false)
      }, error => { console.log(error) })
    }).catch(e => {
      this.messageService.add({ severity: 'warn', detail: e })
      console.log(e)
      // this.PasswordMessage = e
    })
  }

  azureLogin () {
    this.fuseqUser.session = null
    this.loading.set(true)

    this.msalService.loginPopup({
      scopes: ['user.read'],
      prompt: 'select_account'
    }).subscribe({
      next: (result) => {
        console.log('azure login result', result)
        this.msalService.instance.setActiveAccount(result.account)
        this.apiService.mfa(result.accessToken).subscribe({
          next: (data) => {
            this.fuseqUser.session = data
            this.fuseqRaiden.updateUserId(data.username)
            this.messageService.add({ severity: 'success', detail: 'Login successful' })
            let destination = ''
            if (data.permissions.indexOf('OPERATOR') !== -1) {
              destination = '/awpDashboard/wf/awp-workflowFortinet'
            } else if (data.permissions.indexOf('OPERATOR_CISCO') !== -1) {
              destination = '/awpDashboardCisco/wf/awp-workflowCisco'
            } else if (data.permissions.indexOf('MENU_AWP_DASHBOARD_CISCO_ACTIONS') !== -1) {
              destination = '/awpDashboardCisco/actionsDashboard'
            } else if (data.permissions.indexOf('MENU_AWP_DASHBOARD') !== -1) {
              destination = 'awpDashboard/dashboard'
            } else if (data.permissions.indexOf('MENU_VOIP_DASHBOARD') !== -1) {
              destination = '/voip/voip-dashboard'
            } else if (data.permissions.indexOf('MENU_VOIP_DASHBOARD_NPFASTWEB') !== -1) {
              destination = '/voipfastweb/voip-dashboardNPFastweb'
            } else if (data.permissions.indexOf('MENU_NRD_Dashboard') !== -1) {
              destination = '/NRD/NRD-dashboard'
            } else {
              destination = '/awpDashboard/actionsDashboard'
            }
            if (data.groups && data.groups.indexOf('Immobiliare') !== -1) {
              destination = '/awpDashboard/rtu_pianificazioni'
            }
            if (data.groups && data.groups.indexOf('TopManagement') !== -1) {
              destination = '/perimetro-awp'
            }
            const dashboardRoute = destination
            const redirectRoute = this.returnUrl && this.returnUrl !== '**' ? this.returnUrl : dashboardRoute
            this.delay(500).then(async () => await this.router.navigateByUrl(redirectRoute)).finally(() => {
              this.loading.set(false)
            })
            this.setLoginDisplay()
          },
          error: (error) => {
            console.log('node ', error)
            this.loading.set(false)
            if (!error?.isintercepted) {
              this.messageService.add({ severity: 'error', detail: 'Login Failed' })
            }
          }
        })
      },
      error: (error) => {
        this.loading.set(false)
        console.log('azure login error', error)
        if (!error?.isintercepted) {
          this.messageService.add({ severity: 'error', detail: 'Microsoft login failed' })
        }
      }
    })
  }

  loginDisplay = false
  setLoginDisplay () {
    console.log(this.msalService.instance.getAllAccounts())
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0
  }
}
